// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".answers--ch839{display:flex;flex-direction:column;gap:6px;margin-top:4px}.answer--wtUUt{display:flex;flex-direction:column;gap:1px}.answer-header--FfqAK{font-weight:600;font-size:12px;color:#798294}.answer-value--kXx1F{color:#24282f}.dismissed--g8agQ{margin-top:4px;color:#96a0b4;font-style:italic}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"answers": "answers--ch839",
	"answer": "answer--wtUUt",
	"answer-header": "answer-header--FfqAK",
	"answer-value": "answer-value--kXx1F",
	"dismissed": "dismissed--g8agQ"
};
export default ___CSS_LOADER_EXPORT___;
